import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AreaPage from '../pages/Admin/AreaPage';
import CategoriaPage from '../pages/Admin/CategoriaPage';
import ParametrosPage from '../pages/Admin/ParametrosPage';
import RolPage from '../pages/Admin/RolPage';
import VerTareasAreaPage from '../pages/Admin/VerTareasAreaPage';
import AdministrarUsuariosPage from '../pages/Admin/AdministrarUsuariosPage';
import EstadisticasPage from '../pages/Admin/EstadisticasPage';


const AdminRoutes = () => (
  <Routes>
    <Route path="parametros" element={<ParametrosPage />} />
    <Route path="area" element={<AreaPage />} />
    <Route path="categoria" element={<CategoriaPage />} />
    <Route path="rol" element={<RolPage />} />
    <Route path="tareas-area" element={<VerTareasAreaPage />} />
    <Route path="estadisticas" element={<EstadisticasPage />} />
    <Route path="administrar-usuarios" element={<AdministrarUsuariosPage />} />
    <Route path="*" element={<Navigate to="parametros" replace />} />
  </Routes>
);

export default AdminRoutes;
